var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { setErrorMessage } from '@popup/multichain/actions/message.actions';
import { SteemActionType } from '@popup/steem/actions/action-type.enum';
import { DelegationUtils } from '@popup/steem/utils/delegation.utils';
import Logger from 'src/utils/logger.utils';
export const loadDelegators = (username) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const delegators = yield DelegationUtils.getDelegators(username);
        if (!delegators) {
            dispatch(setErrorMessage('popup_html_error_retrieving_incoming_delegations'));
        }
        const action = {
            type: SteemActionType.FETCH_DELEGATORS,
            payload: { incoming: delegators },
        };
        dispatch(action);
    }
    catch (e) {
        const action = {
            type: SteemActionType.FETCH_DELEGATORS,
            payload: { incoming: null },
        };
        dispatch(action);
        dispatch(setErrorMessage('popup_html_error_retrieving_incoming_delegations'));
        Logger.error(e);
    }
});
export const loadDelegatees = (username) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const action = {
            type: SteemActionType.FETCH_DELEGATEES,
            payload: { outgoing: yield DelegationUtils.getDelegatees(username) },
        };
        dispatch(action);
    }
    catch (e) {
        Logger.error(e);
    }
});
export const loadPendingOutgoingUndelegations = (username) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const action = {
            type: SteemActionType.FETCH_PENDING_OUTGOING_UNDELEGATION,
            payload: {
                pendingOutgoingUndelegation: yield DelegationUtils.getPendingOutgoingUndelegation(username),
            },
        };
        dispatch(action);
    }
    catch (error) {
        Logger.error(error);
    }
});
